<template>
  <div class="industry-capacity-detail">
    <content-block>
      <div style="display:flex;font-size: 18px;line-height: 40px;padding: 0 15px;">
        <b style="flex:1;">属性详情</b>
      </div>
      <el-descriptions :column="3" size="normal" style="padding: 0 15px;">
        <el-descriptions-item label="属性名称">{{ info.name || '--' }}</el-descriptions-item>
        <el-descriptions-item label="属性类型">{{ info.typeDesc || '--' }}</el-descriptions-item>
        <el-descriptions-item label="数值计算单位" v-if="info.type === 'NUM'">{{ info.unitName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="时间精度" v-if="info.type === 'DATE'">{{ info.timePrecision || '--' }}</el-descriptions-item>
        <el-descriptions-item label="属性值1" v-if="info.type === 'BOOLEAN'">{{ info.booleanValue1 || '--' }}</el-descriptions-item>
        <el-descriptions-item label="属性值2" v-if="info.type === 'BOOLEAN'">{{ info.booleanValue2 || '--' }}</el-descriptions-item>
        <el-descriptions-item label="应用场景">商品/物料</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ info.createTime ? this.$options.filters['date-format'](info.createTime) : '--' }}</el-descriptions-item>
        <el-descriptions-item label="创建人">{{ info.createUserName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="创建企业名称">海南小紫医疗科技有限公司</el-descriptions-item>
      </el-descriptions>
    </content-block>
    <TableWithPagination
      class="special"
      :columnList="columnList"
      :tableData="targetLists"
      :sortInfo.sync="sortInfo"
      tableBorder="default"
      :showRightToolbar="false"
      :pagination.sync="pagination"
      @size-change="getTargetLists"
      @current-change="getTargetLists"
      @sort-change="getTargetLists"
      :highHoverRow="false"
      :highlightRow="false"
    />
    <bottom-panel>
      <el-button @click="cancel" style="margin-left: 10px;">取消</el-button>
    </bottom-panel>
  </div>
</template>
<script>
import { detailAttribute, getAttributeItemPageList } from '@/api/PlatformSales/ProductAttributes';
import TableWithPagination, { TablePaginationMixin } from '@/components/common/TableWithPagination';
export default {
  name: 'DetailProductAttributes',
  data () {
    return {
      query: {},
      info: {},
      targetLists: [],
    };
  },
  components: {
    TableWithPagination,
  },
  mixins: [TablePaginationMixin],
  methods: {
    cancel () {
      this.$router.go(-1);
      this.$tabs.close({
        to: this.$route.query.fullPath,
        refresh: true,
      });
    },
    getDetailInfo () {
      if (!this.$route.query.id) return;
      detailAttribute({ id: this.$route.query.id }).then(({body}) => {
        this.info = body || {};
      });
    },
    getTargetLists () {
      getAttributeItemPageList({
        attributeId: this.$route.query.id,
        pageFlag: false,
      }).then(({body})=> {
        this.targetLists = body.list || [];
      });
    },
    initPage () {
      this.getDetailInfo();
      this.getTargetLists();
    },
  },
  watch: {
    '$route.name': {
      handler (value) {
        if (value.includes('PlatformSales_ProductAttributes_detail')) {
          this.initPage();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    columnList () {
      const cols = [
        {
          tooltip: true,
          label: '属性值',
          minWidth: '150px',
          width: '',
          prop: 'attributeValue',
        },
        {
          tooltip: true,
          label: '添加时间',
          minWidth: '150px',
          width: '',
          prop: 'createTime',
          format: this.$options.filters['date-format'],
        },
        {
          tooltip: true,
          label: 'sku编码',
          minWidth: '150px',
          width: '',
          prop: 'sn',
        },
        {
          tooltip: true,
          label: 'spu编号',
          minWidth: '150px',
          width: '',
          prop: 'spuCode',
        },
        {
          tooltip: true,
          label: '商品分类',
          minWidth: '180px',
          width: '',
          prop: 'categoryName',
        },
        {
          tooltip: true,
          label: '添加人',
          minWidth: '120px',
          width: '',
          prop: 'createBy',
        },
        {
          tooltip: true,
          label: '添加店铺',
          minWidth: '50px',
          width: '',
          prop: 'storeName',
        },
      ];
      return cols;
    },
  },
  created () {
    this.initPage();
  },
};
</script>
<style lang="scss" scoped>
.industry-capacity-detail {
  .gap-top-10 {
    margin-top: 10px;
  }

  .tag-wrapper {
    padding: 5px 0;
    line-height: 30px;
  }
  .el-tag {
    margin-right: 10px;
  }
}
</style>
